import { useAuth } from '../contexts/AuthContext'

const FALLBACK = 'en-AU'

/**
 * Organization locale (BCP 47) for dates, numbers, and receipts.
 * Prefer this over `navigator.language` so formatting matches store settings.
 */
export function useOrgLocale(): string {
  const { user } = useAuth()
  const raw = user?.organizationLocale?.trim()
  return raw || FALLBACK
}
